import { render, staticRenderFns } from "./tasks-kanban-view.vue?vue&type=template&id=8434cbb8&scoped=true"
import script from "./tasks-kanban-view.vue?vue&type=script&lang=js"
export * from "./tasks-kanban-view.vue?vue&type=script&lang=js"
import style0 from "./tasks-kanban-view.vue?vue&type=style&index=0&id=8434cbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8434cbb8",
  null
  
)

export default component.exports